import { render } from "./layout.vue?vue&type=template&id=58b47685&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=58b47685&lang=less&scoped=true"
import "./layout.vue?vue&type=style&index=1&id=58b47685&lang=less"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b47685"],['__file',"src/views/layout/layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58b47685"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58b47685', __exports__)) {
    console.log('reload')
    api.reload('58b47685', __exports__)
  }
  
  module.hot.accept("./layout.vue?vue&type=template&id=58b47685&scoped=true", () => {
    console.log('re-render')
    api.rerender('58b47685', render)
  })

}


export default __exports__